import { Box, Text } from "grommet";
import React from "react";

import useBook from "../../hooks/useBook";

import ArchiveCanvas from "../../shared_comp/ArchiveCanvas";
import SectionTitle from "../../shared_comp/SectionTitle";
import MainCanvas from "../../shared_comp/MainCanvas";
import Working from "../../shared_comp/Working";
import BookGroupList from "../../shared_comp/BookGroupList";

const SchoolCatalogueMain = () => {
    const [received, setReceived] = React.useState(false);
    const [booksAchoolCatalogue, setBooksAchoolCatalogue] = React.useState<any>([]);
    const [pubList, setPubList] = React.useState<any>([]);
    const [schoolCatalogueGroup, setAchoolCatalogueGroup] = React.useState<any>([]);
    const [readyAchoolCatalogue, setReadyAchoolCatalogue] = React.useState(false);

    React.useEffect(() => {
        const receiveData = async () => {
            const res = await useBook.getBookList("school_catalogue");
            setBooksAchoolCatalogue(res.books);
            setReceived(true);
        };
        receiveData();
    }, []);
    // console.log("AchoolCatalogue", booksAchoolCatalogue)
    React.useEffect(() => {
        // received.length >0
        if (booksAchoolCatalogue.length > 0) {
            let bGroup: { [key: string]: string[] } = {};
            let publisherList: string[] = [];

            booksAchoolCatalogue.forEach((b: any) => {
                if (b.publisher === null) {
                    b.publisher = "기타";
                }
                b.publisher = b.publisher.trim();
                if (b.publisher === "") {
                    b.publisher = "기타";
                }

                let pubkey = b.publisher;
                // delete after ';' in pubkey
                let pubdiv = pubkey.split(";");
                pubkey = pubdiv[0];
                if (pubkey in bGroup) {
                    bGroup[pubkey].push(b);
                } else {
                    bGroup[pubkey] = [b];
                }
                if (publisherList.indexOf(pubkey) < 0) {
                    publisherList.push(pubkey);
                }
            });
            // move '기타' at last of publisherList
            publisherList.sort();
            let idx = publisherList.indexOf("기타");
            if (idx > 0) {
                publisherList.splice(idx, 1);
                publisherList.push("기타");
            }
            setPubList(publisherList);
            // console.log("pubList", publisherList);
            // sort bGroup by pubkey
            setAchoolCatalogueGroup(bGroup);
            // console.log("AchoolCatalogueGroup", bGroup)
            setReadyAchoolCatalogue(true);
        }
    }, [booksAchoolCatalogue]);
    return (
        <ArchiveCanvas>
            <SectionTitle title="참고자료 / 학교출간물" />
            <MainCanvas>
                {readyAchoolCatalogue && (
                    <BookGroupList
                        groupData={schoolCatalogueGroup}
                        groupList={pubList}
                    />
                )}
            </MainCanvas>
        </ArchiveCanvas>
    );
};
export default SchoolCatalogueMain;
